import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { interval, Subject } from 'rxjs'
import { takeUntil, take } from 'rxjs/operators'
import { DetailsService } from '../../pages/settings/services/details.service'
import { DateService } from '../../services/date.service'

@Component({
  selector: 'app-digital-clock',
  templateUrl: './digital-clock.component.html',
  styleUrls: ['./digital-clock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DigitalClockComponent implements OnInit, OnDestroy {
  currentTime: string = ''
  clientTimezone: string = ''
  private destroy$ = new Subject<void>()

  constructor(private detailsService: DetailsService, private dateService: DateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initializeClock()
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  private initializeClock(): void {
    // Get client timezone first
    this.detailsService
      .getCurrentClientBy('time_zone')
      .pipe(take(1))
      .subscribe((client) => {
        if (client?.time_zone !== undefined) {
          this.clientTimezone = `GMT${client.time_zone > 0 ? '+' + client.time_zone : client.time_zone}`
          this.updateTime()
          this.startClock()
        }
      })
  }

  private startClock(): void {
    // Update the clock every second
    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateTime()
      })
  }

  private updateTime(): void {
    const now = new Date()
    // Use the DateService to format time according to client timezone
    this.currentTime = this.dateService.dateByTimezone(now, 'HH:mm:ss') ?? ''
    this.cdr.markForCheck()
  }
}
